import React, { useEffect ,useState} from 'react'
import axios from 'axios';
import config from '../../config';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import Pagination from '../../Components/Pagination/Pagination'
import { ChevronRight , ChevronLeft} from 'lucide-react';




const SubscriptionFailed = () => {

    const [subscriptionCustomer, setSubscriptionCustomer] = useState([]);
        const [index, SetIndex] = useState(0);
        const [size, SetSize] = useState(1000);
        const [View1Pagination, SetView1Pagination] = useState(true);
        const [View2Pagination, SetView2Pagination] = useState(false);
    
    const navigate = useNavigate();
  
    // Fonction pour récupérer les commandes de l'utilisateur
    const getSubscriptionCustomer = async () => {
        try {
            const token = localStorage.getItem("accessToken"); // Assurez-vous que le token est stocké ici
            const response = await axios.post(`${config.FIS_API_SITE}/getsubscriptionfailed`, {
              index: index,
              size: size,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
    
      setSubscriptionCustomer(response.data.result || []); // Extraire le tableau subscriptionCustomer
        } catch (error) {
            toast.error(error.response?.data?.message || "Erreur lors de la récupération des commandes");
        }
    };
    // Appeler fetchsubscriptionCustomer au montage du composant
    useEffect(() => {
      getSubscriptionCustomer();
    }, []);

 // Gestion des clics sur les numéros de page
 const handleClickpaginate = (e) => {
  const page = parseInt(e.target.value, 10);
  SetIndex(page);
  getSubscriptionCustomer(page, size);
};

// Gestion du changement dans le select (nombre d'éléments par page)
const onChangeSelectpagination = (e) => {
  const newLimit = parseInt(e.target.value, 10);
  SetSize(newLimit);
  getSubscriptionCustomer(1, newLimit); // Revenir à la première page avec le nouveau limit
  SetIndex(1);
  SetView1Pagination(true);
  SetView2Pagination(false);
};
  return (
    <div className="mt-4">
        <h3 className="mb-4">Les Abonnement Annulée</h3>
        <div class="relative flex flex-col w-full h-full overflow-scroll text-gray-700 bg-white shadow-md rounded-lg bg-clip-border">
    <table class="w-full text-left table-auto min-w-max">
        <thead>
        <tr>
            <th class="p-4 border-b border-slate-200 bg-slate-50">
            <p class="text-sm font-normal leading-none text-slate-500">
                N° Pack
            </p>
            </th>
            <th class="p-4 border-b border-slate-200 bg-slate-50">
            <p class="text-sm font-normal leading-none text-slate-500">
                Nom de Pack
            </p>
            </th>
            <th class="p-4 border-b border-slate-200 bg-slate-50">
            <p class="text-sm font-normal leading-none text-slate-500">
                Nombre de story de Pack
            </p>
            </th>
            <th class="p-4 border-b border-slate-200 bg-slate-50">
            <p class="text-sm font-normal leading-none text-slate-500">
                Nom de stories restant
            </p>
            </th>
            <th class="p-4 border-b border-slate-200 bg-slate-50">
            <p class="text-sm font-normal leading-none text-slate-500">
                Total de Prix
            </p>
            </th>
            <th class="p-4 border-b border-slate-200 bg-slate-50">
            <p class="text-sm font-normal leading-none text-slate-500">
                Date d'Abonnement
            </p>
            </th>
            <th class="p-4 border-b border-slate-200 bg-slate-50">
            <p class="text-sm font-normal leading-none text-slate-500">
                Date Fin d'Abonnement
            </p>
            </th>
        </tr>
        </thead>
        <tbody>
        {subscriptionCustomer.map((o, i) => (
                  <tr key={i} className="hover:bg-slate-50 border-b border-slate-200">
                    <td className="p-4">
                      <p className="block font-semibold text-sm text-slate-800">{o?.code_subscription}</p>
                    </td>
                    <td className="p-4">
                      <p className="text-sm text-slate-500">{o?.subscriptionId?.title}</p>
                    </td>
                    <td className="p-4">
                      <p className="text-sm text-slate-500">{o?.subscriptionId?.nbr_doc}</p>
                    </td>
                    <td className="p-4">
                      <p className="text-sm text-slate-500">{o?.number_document}</p>
                    </td>
                    <td className="p-4">
                      <p className="text-sm text-slate-500">{o?.subscriptionId?.price}</p>
                    </td>
                    <td className="p-4">
                      <p className="text-sm text-slate-500">
                        {o?.date_subscription ? new Date(o.date_subscription).toLocaleDateString('fr-FR') : 'N/A'}
                      </p>
                    </td>
                    <td className="p-4">
                      <p className="text-sm text-slate-500">
                        {o?.date_fin_subscription ? new Date(o.date_fin_subscription).toLocaleDateString('fr-FR') : 'N/A'}
                      </p>
                    </td>
                  </tr>
                ))}
        </tbody>
    </table>
    
          {/* Nouvelle pagination */}
          <div className="flex flex-wrap items-center mt-3 intro-y min-sm:flex-row min-sm:flex-nowrap">
            <Pagination className="w-full min-sm:w-auto min-sm:mr-auto">
              {View1Pagination && (
                <>
                  <Pagination.Link>
                   <ChevronLeft className="w-4 h-4" />
                  </Pagination.Link>
                  <Pagination.Link>
                    <button value={1} onClick={handleClickpaginate}>
                      1
                    </button>
                  </Pagination.Link>
                  <Pagination.Link>
                    <button value={2} onClick={handleClickpaginate}>
                      2
                    </button>
                  </Pagination.Link>
                  <Pagination.Link>
                    <button value={3} onClick={handleClickpaginate}>
                      3
                    </button>
                  </Pagination.Link>
                  <Pagination.Link>
                    <ChevronRight
                      className="w-4 h-4"
                      onClick={() => {
                        SetView1Pagination(false);
                        SetView2Pagination(true);
                        SetIndex(4);
                        getSubscriptionCustomer(4, size);
                      }}
                    /> 
                  </Pagination.Link>
                </>
              )}
              {View2Pagination && (
                <>
                  <Pagination.Link>
                    <ChevronLeft
                      className="w-4 h-4"
                      onClick={() => {
                        SetView1Pagination(true);
                        SetView2Pagination(false);
                        SetIndex(1);
                        getSubscriptionCustomer(1, size);
                      }}
                    /> 
                  </Pagination.Link>
                  <Pagination.Link>
                    <button value={4} onClick={handleClickpaginate}>
                      4
                    </button>
                  </Pagination.Link>
                  <Pagination.Link>
                    <button value={5} onClick={handleClickpaginate}>
                      5
                    </button>
                  </Pagination.Link>
                  <Pagination.Link>
                    <button value={6} onClick={handleClickpaginate}>
                      6
                    </button>
                  </Pagination.Link>
                  <Pagination.Link>
                    <ChevronRight className="w-4 h-4" /> 
                  </Pagination.Link>
                </>
              )}
            </Pagination>
            <select
              className="w-20 mt-3 p-2 m-3 border rounded-md shadow-sm min-sm:mt-0 focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={onChangeSelectpagination}
            >
              <option value={1000}>1000</option>
              <option value={2000}>2000</option>
              <option value={3000}>3000</option>
              <option value={4000}>4000</option>
              <option value={5000}>5000</option>
            </select>
          </div>
    </div>
      </div>
  )
}

export default SubscriptionFailed